module.exports = __webpack_public_path__ + "media/video.685be168.mp4";